import * as React from "react";
import { Context } from "./_context";
export const NavigationOffersIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m11.166 1.009 9 1a1.5 1.5 0 0 1 1.325 1.325l1 9a1.5 1.5 0 0 1-.43 1.227l-9.5 9.5a1.5 1.5 0 0 1-2.121 0l-10-10a1.5 1.5 0 0 1 0-2.121l9.5-9.5a1.5 1.5 0 0 1 1.226-.431ZM3.621 12l7.879 7.88 7.93-7.93-.788-7.091-7.091-.788L3.62 12ZM14.75 7a1.75 1.75 0 1 1-.001 3.501 1.75 1.75 0 0 1 .001-3.5Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationOffersIcon.iconId = "8wbKM0";
